import {createApp} from 'vue'
import App from './App.vue';
import "./utils/rem"

const app = createApp(App);

// 引入vant
import * as Vant from 'vant';
import 'vant/lib/index.css'; // 引入Vant的样式文件
import "@/assets/css/index.css"
Object.values(Vant).forEach((component) => {
    app.component(component.name, component);
});

// 引入路由
import router from './router/router'

app.use(Vant)
app.use(router)
app.mount('#app')

